import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#course-trainnning-statistics",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Course Category Report")
  ])
], -1)
const _hoisted_3 = {
  id: "course-trainnning-statistics",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tranche")
], -1)
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Training Partner")
], -1)
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Stage", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { class: "row mt-3" }
const _hoisted_16 = { class: "col-md-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Course Category")
], -1)
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Start Date")
], -1)
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "End Date")
], -1)
const _hoisted_22 = { class: "col-md-1 mt-3 p-0" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_24 = { class: "position-relative mt-7" }
const _hoisted_25 = {
  id: "courseTReport",
  class: "collapse show"
}
const _hoisted_26 = { class: "collapse show" }
const _hoisted_27 = { class: "row w-100 mb-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 my-auto" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "m-0" }, "Course Category Report")
], -1)
const _hoisted_29 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "col-md-12 table-responsive sticky p-0" }
const _hoisted_37 = {
  key: 0,
  class: "table table-borderless",
  style: {"border":"1.5px solid #23ce10"}
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("thead", {
  style: {"border-left":"1.5px solid #23ce10"},
  class: "sticky-header"
}, [
  /*#__PURE__*/_createElementVNode("tr", {
    class: "fw-bolder bg-light text-black",
    style: {"border-bottom":"1px solid #23ce10"}
  }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Sl "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Industry Association/Organization "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Total Target (As Per Contract) "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "3"
    }, " Enrollment "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "3"
    }, " Assessment "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "3"
    }, " Certification "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "3"
    }, " Job Placement ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", {
    class: "fw-bolder bg-light text-black",
    style: {"border-bottom":"1px solid #23ce10"}
  }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Male "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Male "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center"} }, "Total"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Male "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center"} }, "Total"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Male "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Female ")
  ])
], -1)
const _hoisted_39 = { style: {} }
const _hoisted_40 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "16"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("tr", null, null, -1)
const _hoisted_42 = { class: "text-start" }
const _hoisted_43 = { class: "text-center" }
const _hoisted_44 = { class: "text-center" }
const _hoisted_45 = { class: "text-center" }
const _hoisted_46 = { class: "text-center" }
const _hoisted_47 = { class: "text-center" }
const _hoisted_48 = { class: "text-center" }
const _hoisted_49 = { class: "text-center" }
const _hoisted_50 = { class: "text-center" }
const _hoisted_51 = { class: "text-center" }
const _hoisted_52 = { class: "text-center" }
const _hoisted_53 = { class: "text-center" }
const _hoisted_54 = { class: "text-center" }
const _hoisted_55 = { class: "border border-gray-400 text-center" }
const _hoisted_56 = {
  colspan: "2",
  class: "font-weight-bold"
}
const _hoisted_57 = { class: "font-weight-bold" }
const _hoisted_58 = { class: "font-weight-bold" }
const _hoisted_59 = { class: "font-weight-bold" }
const _hoisted_60 = { class: "font-weight-bold" }
const _hoisted_61 = { class: "font-weight-bold" }
const _hoisted_62 = { class: "font-weight-bold" }
const _hoisted_63 = { class: "font-weight-bold" }
const _hoisted_64 = { class: "font-weight-bold" }
const _hoisted_65 = { class: "font-weight-bold" }
const _hoisted_66 = { class: "font-weight-bold" }
const _hoisted_67 = { class: "font-weight-bold" }
const _hoisted_68 = { class: "font-weight-bold" }
const _hoisted_69 = { class: "font-weight-bold" }
const _hoisted_70 = { class: "border border-gray-400 text-center" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "font-weight-bold"
}, " Grand Total (All Category) ", -1)
const _hoisted_72 = { class: "font-weight-bold" }
const _hoisted_73 = { class: "font-weight-bold" }
const _hoisted_74 = { class: "font-weight-bold" }
const _hoisted_75 = { class: "font-weight-bold" }
const _hoisted_76 = { class: "font-weight-bold" }
const _hoisted_77 = { class: "font-weight-bold" }
const _hoisted_78 = { class: "font-weight-bold" }
const _hoisted_79 = { class: "font-weight-bold" }
const _hoisted_80 = { class: "font-weight-bold" }
const _hoisted_81 = { class: "font-weight-bold" }
const _hoisted_82 = { class: "font-weight-bold" }
const _hoisted_83 = { class: "font-weight-bold" }
const _hoisted_84 = { class: "font-weight-bold" }
const _hoisted_85 = {
  key: 1,
  class: "table table-borderless",
  style: {"border":"1.5px solid #23ce10"}
}
const _hoisted_86 = /*#__PURE__*/_createElementVNode("thead", {
  style: {"border-left":"1.5px solid #23ce10"},
  class: "sticky-header"
}, [
  /*#__PURE__*/_createElementVNode("tr", {
    class: "fw-bolder bg-light text-black",
    style: {"border-bottom":"1px solid #23ce10"}
  }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Sl "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Industry Association/Organization "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Total Target (As Per Contract) "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "3"
    }, " Enrollment ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", {
    class: "fw-bolder bg-light text-black",
    style: {"border-bottom":"1px solid #23ce10"}
  }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Male "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Female ")
  ])
], -1)
const _hoisted_87 = { style: {} }
const _hoisted_88 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "16"
}
const _hoisted_89 = /*#__PURE__*/_createElementVNode("tr", null, null, -1)
const _hoisted_90 = { class: "text-start" }
const _hoisted_91 = { class: "text-center" }
const _hoisted_92 = { class: "text-center" }
const _hoisted_93 = { class: "text-center" }
const _hoisted_94 = { class: "border border-gray-400 text-center" }
const _hoisted_95 = {
  colspan: "2",
  class: "font-weight-bold"
}
const _hoisted_96 = { class: "font-weight-bold" }
const _hoisted_97 = { class: "font-weight-bold" }
const _hoisted_98 = { class: "font-weight-bold" }
const _hoisted_99 = { class: "font-weight-bold" }
const _hoisted_100 = {
  key: 0,
  class: "border border-gray-400 text-center"
}
const _hoisted_101 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "font-weight-bold"
}, " Grand Total (All Category) ", -1)
const _hoisted_102 = { class: "font-weight-bold" }
const _hoisted_103 = { class: "font-weight-bold" }
const _hoisted_104 = { class: "font-weight-bold" }
const _hoisted_105 = { class: "font-weight-bold" }
const _hoisted_106 = {
  key: 2,
  class: "table table-borderless",
  style: {"border":"1.5px solid #23ce10"}
}
const _hoisted_107 = /*#__PURE__*/_createElementVNode("thead", {
  style: {"border-left":"1.5px solid #23ce10"},
  class: "sticky-header"
}, [
  /*#__PURE__*/_createElementVNode("tr", {
    class: "fw-bolder bg-light text-black",
    style: {"border-bottom":"1px solid #23ce10"}
  }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Sl "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Industry Association/Organization "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Total Target (As Per Contract) "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "3"
    }, " Assessment ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", {
    class: "fw-bolder bg-light text-black",
    style: {"border-bottom":"1px solid #23ce10"}
  }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Male "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Female ")
  ])
], -1)
const _hoisted_108 = { style: {} }
const _hoisted_109 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "16"
}
const _hoisted_110 = /*#__PURE__*/_createElementVNode("tr", null, null, -1)
const _hoisted_111 = { class: "text-start" }
const _hoisted_112 = { class: "text-center" }
const _hoisted_113 = { class: "text-center" }
const _hoisted_114 = { class: "text-center" }
const _hoisted_115 = { class: "border border-gray-400 text-center" }
const _hoisted_116 = {
  colspan: "2",
  class: "font-weight-bold"
}
const _hoisted_117 = { class: "font-weight-bold" }
const _hoisted_118 = { class: "font-weight-bold" }
const _hoisted_119 = { class: "font-weight-bold" }
const _hoisted_120 = { class: "font-weight-bold" }
const _hoisted_121 = { class: "border border-gray-400 text-center" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "font-weight-bold"
}, " Grand Total (All Category) ", -1)
const _hoisted_123 = { class: "font-weight-bold" }
const _hoisted_124 = { class: "font-weight-bold" }
const _hoisted_125 = { class: "font-weight-bold" }
const _hoisted_126 = { class: "font-weight-bold" }
const _hoisted_127 = {
  key: 3,
  class: "table table-borderless",
  style: {"border":"1.5px solid #23ce10"}
}
const _hoisted_128 = /*#__PURE__*/_createElementVNode("thead", {
  style: {"border-left":"1.5px solid #23ce10"},
  class: "sticky-header"
}, [
  /*#__PURE__*/_createElementVNode("tr", {
    class: "fw-bolder bg-light text-black",
    style: {"border-bottom":"1px solid #23ce10"}
  }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Sl "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Industry Association/Organization "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Total Target (As Per Contract) "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "3"
    }, " Certification ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", {
    class: "fw-bolder bg-light text-black",
    style: {"border-bottom":"1px solid #23ce10"}
  }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Male "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Female ")
  ])
], -1)
const _hoisted_129 = { style: {} }
const _hoisted_130 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "16"
}
const _hoisted_131 = /*#__PURE__*/_createElementVNode("tr", null, null, -1)
const _hoisted_132 = { class: "text-start" }
const _hoisted_133 = { class: "text-center" }
const _hoisted_134 = { class: "text-center" }
const _hoisted_135 = { class: "text-center" }
const _hoisted_136 = { class: "border border-gray-400 text-center" }
const _hoisted_137 = {
  colspan: "2",
  class: "font-weight-bold"
}
const _hoisted_138 = { class: "font-weight-bold" }
const _hoisted_139 = { class: "font-weight-bold" }
const _hoisted_140 = { class: "font-weight-bold" }
const _hoisted_141 = { class: "font-weight-bold" }
const _hoisted_142 = { class: "border border-gray-400 text-center" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "font-weight-bold"
}, " Grand Total (All Category) ", -1)
const _hoisted_144 = { class: "font-weight-bold" }
const _hoisted_145 = { class: "font-weight-bold" }
const _hoisted_146 = { class: "font-weight-bold" }
const _hoisted_147 = { class: "font-weight-bold" }
const _hoisted_148 = {
  key: 4,
  class: "table table-borderless",
  style: {"border":"1.5px solid #23ce10"}
}
const _hoisted_149 = /*#__PURE__*/_createElementVNode("thead", {
  style: {"border-left":"1.5px solid #23ce10"},
  class: "sticky-header"
}, [
  /*#__PURE__*/_createElementVNode("tr", {
    class: "fw-bolder bg-light text-black",
    style: {"border-bottom":"1px solid #23ce10"}
  }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Sl "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Industry Association/Organization "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Total Target (As Per Contract) "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "3"
    }, " Job Placement ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", {
    class: "fw-bolder bg-light text-black",
    style: {"border-bottom":"1px solid #23ce10"}
  }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Male "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Female ")
  ])
], -1)
const _hoisted_150 = { style: {} }
const _hoisted_151 = {
  style: {"text-align":"left","font-weight":"bold"},
  colspan: "16"
}
const _hoisted_152 = /*#__PURE__*/_createElementVNode("tr", null, null, -1)
const _hoisted_153 = { class: "text-start" }
const _hoisted_154 = { class: "text-center" }
const _hoisted_155 = { class: "text-center" }
const _hoisted_156 = { class: "text-center" }
const _hoisted_157 = { class: "border border-gray-400 text-center" }
const _hoisted_158 = {
  colspan: "2",
  class: "font-weight-bold"
}
const _hoisted_159 = { class: "font-weight-bold" }
const _hoisted_160 = { class: "font-weight-bold" }
const _hoisted_161 = { class: "font-weight-bold" }
const _hoisted_162 = { class: "font-weight-bold" }
const _hoisted_163 = { class: "border border-gray-400 text-center" }
const _hoisted_164 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "font-weight-bold"
}, " Grand Total (All Category) ", -1)
const _hoisted_165 = { class: "font-weight-bold" }
const _hoisted_166 = { class: "font-weight-bold" }
const _hoisted_167 = { class: "font-weight-bold" }
const _hoisted_168 = { class: "font-weight-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.TranceData,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.TranceData) = $event)),
                  options: _ctx.optionsTranche,
                  mode: "tags",
                  "clear-on-select": false,
                  placeholder: "Select Tranche",
                  "close-on-select": false,
                  searchable: true,
                  "create-option": true
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.TpartnerData,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.TpartnerData) = $event)),
                  options: _ctx.optionsTPartner,
                  mode: "tags",
                  "clear-on-select": false,
                  placeholder: "Select Training Partner",
                  "close-on-select": false,
                  searchable: true,
                  "create-option": true
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _hoisted_14,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "--Select--",
                  modelValue: _ctx.report_type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.report_type) = $event)),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, { value: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("--Select--")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      value: "1",
                      label: "Enrollment"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Enrollment")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      value: "2",
                      label: "Assessment"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Assessment")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      value: "3",
                      label: "Certification"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Certification")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      value: "4",
                      label: "Employment"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Employment")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_Multiselect, {
                    modelValue: _ctx.TcategoryData,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.TcategoryData) = $event)),
                    options: _ctx.optionsTCategory,
                    mode: "tags",
                    "clear-on-select": false,
                    placeholder: "Select Category",
                    "close-on-select": false,
                    searchable: true,
                    "create-option": true
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_el_form_item, {
                    prop: "date",
                    class: "mb-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.start_date,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.start_date) = $event)),
                        "value-format": "YYYY-MM-DD",
                        format: "DD-MM-YYYY",
                        type: "date",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(_component_el_form_item, {
                    prop: "date",
                    class: "mb-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.end_date,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.end_date) = $event)),
                        "value-format": "YYYY-MM-DD",
                        format: "DD-MM-YYYY",
                        type: "date",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.categoryReport())),
                    type: "button",
                    class: "btn btn-success mt-6 p-3",
                    style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                  }, [
                    _createTextVNode(" Search "),
                    _hoisted_23
                  ])
                ])
              ])
            ]),
            (_ctx.showTrainningStatistics == true)
              ? _withDirectives((_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                  _createElementVNode("div", _hoisted_24, [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                              title: "Download Xlse",
                              "data-v-54b12dc8": "",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.exportTrainee()))
                            }, _hoisted_31),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                              title: "Download PDF",
                              "data-v-54b12dc8": "",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downloadPdf()))
                            }, _hoisted_33),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                              title: "Print",
                              "data-v-54b12dc8": "",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.printPdf()))
                            }, _hoisted_35)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          (_ctx.allData)
                            ? (_openBlock(), _createElementBlock("table", _hoisted_37, [
                                _hoisted_38,
                                _createElementVNode("tbody", _hoisted_39, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.categoryReportInfo, (info, key) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                      (
                                      info?.subTotalAssesment != 0 &&
                                      info?.subTotalCertified != 0 &&
                                      info?.subTotalEnrollment != 0 &&
                                      info?.subTotalFemaleAssesment != 0 &&
                                      info?.subTotalFemaleCertified != 0 &&
                                      info?.subTotalFemaleJob != 0 &&
                                      info?.subTotalJob != 0 &&
                                      info?.subTotalMaleAssesment != 0 &&
                                      info?.subTotalMaleCertified != 0 &&
                                      info?.subTotalMaleJob != 0 &&
                                      info?.subTotalfemaleEnrollment != 0 &&
                                      info?.subTotalmaleEnrollment != 0 &&
                                      info?.subtotaltarget != 0
                                    )
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_40, _toDisplayString(info?.category_name), 1)
                                            ]),
                                            _hoisted_41,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.entity, (data, inx) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: inx,
                                                class: "border border-gray-400 text-center"
                                              }, [
                                                _createElementVNode("td", null, _toDisplayString(data?.sl), 1),
                                                _createElementVNode("td", _hoisted_42, _toDisplayString(data?.entity_name) + "(" + _toDisplayString(data?.entity_short_name) + ") ", 1),
                                                _createElementVNode("td", null, _toDisplayString(Number(
                                              data?.target
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_43, _toDisplayString(Number(
                                              data?.total_enrollment
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_44, _toDisplayString(Number(
                                              data?.male_enrollment
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_45, _toDisplayString(Number(
                                              data?.female_enrollment
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_46, _toDisplayString(Number(
                                              data?.total_assessment
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_47, _toDisplayString(Number(
                                              data?.male_assessment
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_48, _toDisplayString(Number(
                                              data?.female_assessment
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_49, _toDisplayString(Number(
                                              data?.total_certificate
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_50, _toDisplayString(Number(
                                              data?.male_certified
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_51, _toDisplayString(Number(
                                              data?.female_certified
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_52, _toDisplayString(Number(
                                              data?.total_job
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_53, _toDisplayString(Number(
                                              data?.male_job
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_54, _toDisplayString(Number(
                                              data?.female_job
                                            ).toLocaleString()), 1)
                                              ]))
                                            }), 128)),
                                            _createElementVNode("tr", _hoisted_55, [
                                              _createElementVNode("td", _hoisted_56, " Subtotal(" + _toDisplayString(info?.category_name) + ") ", 1),
                                              _createElementVNode("td", _hoisted_57, _toDisplayString(Number(
                                            info?.subtotaltarget
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_58, _toDisplayString(Number(
                                            info?.subTotalEnrollment
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_59, _toDisplayString(Number(
                                            info?.subTotalmaleEnrollment
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_60, _toDisplayString(Number(
                                            info?.subTotalfemaleEnrollment
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_61, _toDisplayString(Number(
                                            info?.subTotalAssesment
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_62, _toDisplayString(Number(
                                            info?.subTotalMaleAssesment
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_63, _toDisplayString(Number(
                                            info?.subTotalFemaleAssesment
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_64, _toDisplayString(Number(
                                            info?.subTotalCertified
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_65, _toDisplayString(Number(
                                            info?.subTotalMaleCertified
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_66, _toDisplayString(Number(
                                            info?.subTotalFemaleCertified
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_67, _toDisplayString(Number(
                                            info?.subTotalJob
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_68, _toDisplayString(Number(
                                            info?.subTotalMaleJob
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_69, _toDisplayString(Number(
                                            info?.subTotalFemaleJob
                                          ).toLocaleString()), 1)
                                            ])
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128)),
                                  _createElementVNode("tr", _hoisted_70, [
                                    _hoisted_71,
                                    _createElementVNode("td", _hoisted_72, _toDisplayString(Number(
                                        this.FinalTotalTarget
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_73, _toDisplayString(Number(
                                        this.FinalTotalEnrollment
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_74, _toDisplayString(Number(
                                        this.FinalTotalmaleEnrollment
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_75, _toDisplayString(Number(
                                        this.FinalTotalfemaleEnrollment
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_76, _toDisplayString(Number(
                                        this.FinalTotalAssesment
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_77, _toDisplayString(Number(
                                        this.FinalTotalmaleAssesment
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_78, _toDisplayString(Number(
                                        this.FinalTotalFemaleAssesment
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_79, _toDisplayString(Number(
                                        this.FinalTotalCertified
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_80, _toDisplayString(Number(
                                        this.FinalTotalmaleCertified
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_81, _toDisplayString(Number(
                                        this.FinalTotalFemaleCertified
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_82, _toDisplayString(Number(
                                        this.FinalTotalJob
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_83, _toDisplayString(Number(
                                        this.FinalTotalmaleJob
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_84, _toDisplayString(Number(
                                        this.FinalTotalFemaleJob
                                      ).toLocaleString()), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.enrollData)
                            ? (_openBlock(), _createElementBlock("table", _hoisted_85, [
                                _hoisted_86,
                                _createElementVNode("tbody", _hoisted_87, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.categoryReportInfo, (info, key) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                      (
                                      info?.subTotalEnrollment != 0 &&
                                      info?.subTotalfemaleEnrollment != 0 &&
                                      info?.subTotalmaleEnrollment != 0 &&
                                      info?.subtotaltarget != 0
                                    )
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_88, _toDisplayString(info?.category_name), 1)
                                            ]),
                                            _hoisted_89,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.entity, (data, inx) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: inx,
                                                class: "border border-gray-400 text-center"
                                              }, [
                                                _createElementVNode("td", null, _toDisplayString(data?.sl), 1),
                                                _createElementVNode("td", _hoisted_90, _toDisplayString(data?.entity_name) + "(" + _toDisplayString(data?.entity_short_name) + ") ", 1),
                                                _createElementVNode("td", null, _toDisplayString(Number(
                                              data?.target
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_91, _toDisplayString(Number(
                                              data?.total_enrollment
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_92, _toDisplayString(Number(
                                              data?.male_enrollment
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_93, _toDisplayString(Number(
                                              data?.female_enrollment
                                            ).toLocaleString()), 1)
                                              ]))
                                            }), 128)),
                                            _createElementVNode("tr", _hoisted_94, [
                                              _createElementVNode("td", _hoisted_95, " Subtotal(" + _toDisplayString(info?.category_name) + ") ", 1),
                                              _createElementVNode("td", _hoisted_96, _toDisplayString(Number(
                                            info?.subtotaltarget
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_97, _toDisplayString(Number(
                                            info?.subTotalEnrollment
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_98, _toDisplayString(Number(
                                            info?.subTotalmaleEnrollment
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_99, _toDisplayString(Number(
                                            info?.subTotalfemaleEnrollment
                                          ).toLocaleString()), 1)
                                            ])
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128)),
                                  (_ctx.categoryReportInfo.length)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_100, [
                                        _hoisted_101,
                                        _createElementVNode("td", _hoisted_102, _toDisplayString(Number(
                                        this.FinalTotalTarget
                                      ).toLocaleString()), 1),
                                        _createElementVNode("td", _hoisted_103, _toDisplayString(Number(
                                        this.FinalTotalEnrollment
                                      ).toLocaleString()), 1),
                                        _createElementVNode("td", _hoisted_104, _toDisplayString(Number(
                                        this.FinalTotalmaleEnrollment
                                      ).toLocaleString()), 1),
                                        _createElementVNode("td", _hoisted_105, _toDisplayString(Number(
                                        this.FinalTotalfemaleEnrollment
                                      ).toLocaleString()), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.assesmentData)
                            ? (_openBlock(), _createElementBlock("table", _hoisted_106, [
                                _hoisted_107,
                                _createElementVNode("tbody", _hoisted_108, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.categoryReportInfo, (info, key) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                      (
                                      info?.subTotalAssesment != 0 &&
                                      info?.subTotalFemaleAssesment != 0 &&
                                      info?.subTotalMaleAssesment != 0 &&
                                      info?.subtotaltarget != 0
                                    )
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_109, _toDisplayString(info?.category_name), 1)
                                            ]),
                                            _hoisted_110,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.entity, (data, inx) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: inx,
                                                class: "border border-gray-400 text-center"
                                              }, [
                                                _createElementVNode("td", null, _toDisplayString(data?.sl), 1),
                                                _createElementVNode("td", _hoisted_111, _toDisplayString(data?.entity_name) + "(" + _toDisplayString(data?.entity_short_name) + ") ", 1),
                                                _createElementVNode("td", null, _toDisplayString(Number(
                                              data?.target
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_112, _toDisplayString(Number(
                                              data?.total_assessment
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_113, _toDisplayString(Number(
                                              data?.male_assessment
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_114, _toDisplayString(Number(
                                              data?.female_assessment
                                            ).toLocaleString()), 1)
                                              ]))
                                            }), 128)),
                                            _createElementVNode("tr", _hoisted_115, [
                                              _createElementVNode("td", _hoisted_116, " Subtotal(" + _toDisplayString(info?.category_name) + ") ", 1),
                                              _createElementVNode("td", _hoisted_117, _toDisplayString(Number(
                                            info?.subtotaltarget
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_118, _toDisplayString(Number(
                                            info?.subTotalAssesment
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_119, _toDisplayString(Number(
                                            info?.subTotalMaleAssesment
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_120, _toDisplayString(Number(
                                            info?.subTotalFemaleAssesment
                                          ).toLocaleString()), 1)
                                            ])
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128)),
                                  _createElementVNode("tr", _hoisted_121, [
                                    _hoisted_122,
                                    _createElementVNode("td", _hoisted_123, _toDisplayString(Number(
                                        this.FinalTotalTarget
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_124, _toDisplayString(Number(
                                        this.FinalTotalAssesment
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_125, _toDisplayString(Number(
                                        this.FinalTotalmaleAssesment
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_126, _toDisplayString(Number(
                                        this.FinalTotalFemaleAssesment
                                      ).toLocaleString()), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.certificationData)
                            ? (_openBlock(), _createElementBlock("table", _hoisted_127, [
                                _hoisted_128,
                                _createElementVNode("tbody", _hoisted_129, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.categoryReportInfo, (info, key) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                      (
                                      info?.subTotalCertified != 0 &&
                                      info?.subTotalFemaleCertified != 0 &&
                                      info?.subTotalMaleCertified != 0 &&
                                      info?.subtotaltarget != 0
                                    )
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_130, _toDisplayString(info?.category_name), 1)
                                            ]),
                                            _hoisted_131,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.entity, (data, inx) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: inx,
                                                class: "border border-gray-400 text-center"
                                              }, [
                                                _createElementVNode("td", null, _toDisplayString(data?.sl), 1),
                                                _createElementVNode("td", _hoisted_132, _toDisplayString(data?.entity_name) + "(" + _toDisplayString(data?.entity_short_name) + ") ", 1),
                                                _createElementVNode("td", null, _toDisplayString(Number(
                                              data?.target
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_133, _toDisplayString(Number(
                                              data?.total_certificate
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_134, _toDisplayString(Number(
                                              data?.male_certified
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_135, _toDisplayString(Number(
                                              data?.female_certified
                                            ).toLocaleString()), 1)
                                              ]))
                                            }), 128)),
                                            _createElementVNode("tr", _hoisted_136, [
                                              _createElementVNode("td", _hoisted_137, " Subtotal(" + _toDisplayString(info?.category_name) + ") ", 1),
                                              _createElementVNode("td", _hoisted_138, _toDisplayString(Number(
                                            info?.subtotaltarget
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_139, _toDisplayString(Number(
                                            info?.subTotalCertified
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_140, _toDisplayString(Number(
                                            info?.subTotalMaleCertified
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_141, _toDisplayString(Number(
                                            info?.subTotalFemaleCertified
                                          ).toLocaleString()), 1)
                                            ])
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128)),
                                  _createElementVNode("tr", _hoisted_142, [
                                    _hoisted_143,
                                    _createElementVNode("td", _hoisted_144, _toDisplayString(Number(
                                        this.FinalTotalTarget
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_145, _toDisplayString(Number(
                                        this.FinalTotalCertified
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_146, _toDisplayString(Number(
                                        this.FinalTotalmaleCertified
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_147, _toDisplayString(Number(
                                        this.FinalTotalFemaleCertified
                                      ).toLocaleString()), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.jobPlaceData)
                            ? (_openBlock(), _createElementBlock("table", _hoisted_148, [
                                _hoisted_149,
                                _createElementVNode("tbody", _hoisted_150, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.categoryReportInfo, (info, key) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                      (
                                      info?.subTotalFemaleJob != 0 &&
                                      info?.subTotalJob != 0 &&
                                      info?.subTotalMaleJob != 0 &&
                                      info?.subtotaltarget != 0
                                    )
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_151, _toDisplayString(info?.category_name), 1)
                                            ]),
                                            _hoisted_152,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.entity, (data, inx) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: inx,
                                                class: "border border-gray-400 text-center"
                                              }, [
                                                _createElementVNode("td", null, _toDisplayString(data?.sl), 1),
                                                _createElementVNode("td", _hoisted_153, _toDisplayString(data?.entity_name) + "(" + _toDisplayString(data?.entity_short_name) + ") ", 1),
                                                _createElementVNode("td", null, _toDisplayString(Number(
                                              data?.target
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_154, _toDisplayString(Number(
                                              data?.total_job
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_155, _toDisplayString(Number(
                                              data?.male_job
                                            ).toLocaleString()), 1),
                                                _createElementVNode("td", _hoisted_156, _toDisplayString(Number(
                                              data?.female_job
                                            ).toLocaleString()), 1)
                                              ]))
                                            }), 128)),
                                            _createElementVNode("tr", _hoisted_157, [
                                              _createElementVNode("td", _hoisted_158, " Subtotal(" + _toDisplayString(info?.category_name) + ") ", 1),
                                              _createElementVNode("td", _hoisted_159, _toDisplayString(Number(
                                            info?.subtotaltarget
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_160, _toDisplayString(Number(
                                            info?.subTotalJob
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_161, _toDisplayString(Number(
                                            info?.subTotalMaleJob
                                          ).toLocaleString()), 1),
                                              _createElementVNode("td", _hoisted_162, _toDisplayString(Number(
                                            info?.subTotalFemaleJob
                                          ).toLocaleString()), 1)
                                            ])
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128)),
                                  _createElementVNode("tr", _hoisted_163, [
                                    _hoisted_164,
                                    _createElementVNode("td", _hoisted_165, _toDisplayString(Number(
                                        this.FinalTotalTarget
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_166, _toDisplayString(Number(
                                        this.FinalTotalJob
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_167, _toDisplayString(Number(
                                        this.FinalTotalmaleJob
                                      ).toLocaleString()), 1),
                                    _createElementVNode("td", _hoisted_168, _toDisplayString(Number(
                                        this.FinalTotalFemaleJob
                                      ).toLocaleString()), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])), [
                      [_directive_loading, _ctx.load]
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.load]
                ])
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}